export const PAID_CERT_TYPE_ID = 1;
export const UNPAID_CERT_TYPE_ID = 2;

export const NEW_CERT_STATE_ID = 1;
export const PAID_ACTIVE_CERT_STATE_ID = 3;
export const FREE_ACTIVE_CERT_STATE_ID = 5;

export const RUB_CURRENCY_ID = 4;
